import { Table, TableTrProps } from '@mantine/core';
import clsx from 'clsx';
import { forwardRef } from 'react';

export type RegistryTableTrProps = TableTrProps;

export const createRegistryTableTr = () => {
	const RegistryTableTr = forwardRef<HTMLTableRowElement, RegistryTableTrProps>(
		({ className, ...props }, ref) => (
			<Table.Tr
				ref={ref}
				className={clsx('registry-table-tr', className)}
				{...props}
			/>
		),
	);

	return RegistryTableTr;
};
